import '../sass/constructor.scss';

require('fullpage.js');
require('bootstrap/js/tab.js');

import 'slick-carousel';

import {
  fullSectionVideo
} from './video';

import GoogleMap from './map';
import Tabs from './tabs';
import MediatorContacts from './MediatorContacts';

import {
	langToggle,
	searchToggle,
	navToggle,
	// hideHeaderOnScroll,
	showHeaderOnHover
} from './header';

import {
	addAnimationClassOnScroll
} from './animations';

import {
  infoSchemaEffects
} from './schema-old';

import  {
	msnryGrid,
  selectStyler
} from './news';

// import data, { SETTINGS } from './data';
// import SchemaSVG from "./SchemaSVG";

function getDimensions(node) {
	return {
		w: $(node).width(),
		h: $(node).height()
	}
}

const { w, h } = getDimensions('.section');

// const InfoSchemaSVG = new SchemaSVG(data, 'svgSchema', {
// 	w,
// 	h,
// 	svgParams: SETTINGS
// });

// DOM
const $window 					= $(window);
const $body 						= $('body');
const $header						= $('.header');

// videos
const $videoEmbed				= $('.video-embed');

// sliders
const $mainSlider				= $('.slider-front');
const $newsSlider				= $('.news-slider');
const $otherNewsSlider	=	$('.other-news-slider');
const $articleSlider		= $('.article-gallery');
const bigArrowLeftTpl 	= '<a href="#" class="slick-arrow slick-arrow-big slick-prev"><span class="icon-arrow-left"></span></a>';
const bigArrowRightTpl  = '<a href="#" class="slick-arrow slick-arrow-big slick-next"><span class="icon-arrow-right"></span></a>';

// fullpage
const $slideDownArrow 	= $('.slide-down-arrow');
const $page							= $('.page .panel-display .panel-panel > div').first();

// news page
const $newsPage 				= $('.news-page');
const gridNews    	    = document.querySelector('.news-page');

// brand page
const $brandPage				= $('.brand-grid');
const $brandHeader			= $('.brand-header');
const gridBrand	        = document.querySelector('.brand-grid');
const LOADED_CLASS			=	'is-loaded';

// contacts
const $pageContacts			= $('.contacts-page');

// svg
const $schema 					= $('#svgSchema');
const $infoSchema 		  = $('.info-schema-svg');

// map
const map		= new GoogleMap('.map-wrap', '#map');

// tabs
const tabs	= new Tabs('.path-contacts .brand-nav');

(() => {
  // detect IE8 and above, and edge
  if (document.documentMode || /Edge/.test(navigator.userAgent)) {
    $('.info-schema').addClass('is-edge');
  }
  if (!!$infoSchema) {
    infoSchemaEffects();
  }
  if ($('.path-front .video_wrapper').length) {
    $('.path-front .video_wrapper').closest('div').addClass('section fp-auto-height').insertBefore('.page > div > .panel-panel.panel-col > div > .section:first-child');
  }
	$page.attr('id', 'fullpage');
	$('#fullpage').fullpage({
		css3: true,
		scrollingSpeed: 700,
		fitToSection: true,
		fitToSectionDelay: 1000,
		scrollBar: false,
		keyboardScrolling: true,
		parallax: false,
		touchSensitivity: 15,
		normalScrollElementTouchThreshold: 5,
		onLeave: function(index, nextIndex, direction) {
      if (direction == 'down') {
        $header.addClass('hidden');
      } else {
        $header.removeClass('hidden');
      }

			if (nextIndex === 2) {
        // $header.addClass('hidden');
        // $header.addClass('false');
        showHeaderOnHover(false);
				setTimeout(function() {
					addAnimationClassOnScroll();
				}, 900);
      } else if (nextIndex > 1) {
        // $header.addClass('hidden');
        // $header.removeClass('false');
        showHeaderOnHover(true);
      } else {
				$header.removeClass('hidden');
        $header.removeClass('false');
        showHeaderOnHover(false);
      }
		}
	});
  if ($('#fullpage').length) {
    if ($window.width() <= 768) {
      $.fn.fullpage.setResponsive(true);
    }
  }
	$slideDownArrow.on('click', (e) => {
		e.preventDefault();
		$.fn.fullpage.moveSectionDown();
	});
	$mainSlider.slick({
		slide: '.slider-item',
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		swipe: false,
		infinite: true,
		fade: true,
		prevArrow: '<a href="#" class="slick-arrow slick-arrow-big slick-prev"><span class="icon-arrow-left"></span></a>',
		nextArrow: '<a href="#" class="slick-arrow slick-arrow-big slick-next"><span class="icon-arrow-right"></span></a>'
	});
	$newsSlider.slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		swipe: false,
		infinite: false,
		variableWidth: true,
		prevArrow: bigArrowLeftTpl,
		nextArrow: bigArrowRightTpl,
		responsive: [
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 2,
					variableWidth: false
				}
			},
			{
				breakpoint: 641,
				settings: 'unslick'
			}
		]
	});
  $otherNewsSlider.slick({
    variableWidth: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    prevArrow: bigArrowLeftTpl,
    nextArrow: bigArrowRightTpl,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          variableWidth: false
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1
        }
      }
    ]
	});
  $articleSlider.slick({
    variableWidth: true,
    centerMode: true,
    slidesToShow: 1,
		infinite: false,
    prevArrow: bigArrowLeftTpl,
    nextArrow: bigArrowRightTpl,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          centerMode: false,
          variableWidth: false
        }
      }
    ]
  });
  $articleSlider.on('init', function(e, slick) {
	});
	langToggle();
	searchToggle();
	navToggle();
	function setBrandHeaderBg($header, clsImg) {
		const bgUrl = $header.find(clsImg).html();

    $header.css('background-image', `url(${bgUrl})`);
    $header.addClass(LOADED_CLASS);
	}
	// if (!!$newsPage.length) {
	// 	msnryGrid($newsPage, gridNews, '.news-brick','.view-filters');

 //    $('#edit-submit-content').click(function(event) {
 //      setTimeout(function(){
 //        location.reload();
 //      }, 400);
 //    });
	// }
	if (!!$pageContacts.length) {
    const mediatorContacts	=	new MediatorContacts('.contacts-map', '#map', '.map-marker', '.brand-nav');

    mediatorContacts.init();
	}
  if (!!$brandPage.length || $('.contacts-page').length) {
    const $brandVideos = $brandPage.find('.brand-video');

    if ($brandVideos.length) {
      [...$brandVideos].forEach(el => {
        fullSectionVideo($(el));
      });
    }

    setBrandHeaderBg($brandHeader, '.brand-header__cover');
    msnryGrid($brandPage, gridBrand, '.node-teaser', '.size1x1', '.brand-row');
    tabs.init();
    if (!$('.contacts-page').length) {
      map.init();
    }
  }
  selectStyler();
	if ($videoEmbed.length) {
    fullSectionVideo($videoEmbed);
  }
})();

$window.on('scroll', function() {

});

$window.on('resize', function() {
  if ($('#fullpage').length) {
    if ($window.width() <= 768) {
      $.fn.fullpage.setResponsive(true);
    } else {
      $.fn.fullpage.setResponsive(false);
    }
  }
});



// WEBPACK FOOTER //
// ./js/common.js